import { useMutation, useQueryClient } from '@tanstack/react-query';
import { pricingApiConnect } from '../lib/api/pricingApi.connect';
export function useUpdatePricing(projectId, pricingId) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data)=>pricingApiConnect.updatePricing(projectId, pricingId, data),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    'pricing',
                    projectId,
                    pricingId
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'pricing',
                    projectId
                ]
            });
            // Rate-card edits propagate back to the canonical LCAT row via
            // pricingApiConnect.updatePricing → updateLCAT. Invalidate the
            // LCATs cache too so the LCAT tab and stats panel see the new
            // base rate without a manual reload.
            queryClient.invalidateQueries({
                queryKey: [
                    'lcats',
                    projectId
                ]
            });
        }
    });
}
